<template>
    <div>
        <b-row class="mb-2" :key="'formCardRow' + rowIndex" v-for="row, rowIndex in rows">
            <b-col v-if="col.show === undefined || col.show === true" :key="'formCardRowCol' + rowIndex + '_' + colIndex" sm="12" :lg="Core.Display.getlg(col, row.cols)" v-for="col, colIndex in row.cols">
                <FormCards v-model="dataFieldRefs" :fieldRefs="fieldRefs" :form="form" v-if="col.cards !== undefined" :cards="col.cards"></FormCards>
                <FormFields v-model="dataFieldRefs" :fieldRefs="fieldRefs" :form="form" v-if="col.fields !== undefined" :fields="col.fields"></FormFields>
            </b-col>
        </b-row>
    </div>

</template>

<script>

    import FormRows from './FormRows'
    import FormFields from './FormFields'
    import FormCards from './FormCards'
    export default {
      name: 'FormCardRows',
      components: {
          FormCards,
          FormRows,
          FormFields
      },
      props: {
          rows: {
              type: Array,
              default: function() { return [] }
          },
          form: {
              type: Object,
              default: function () { return {} }
          },
          fieldRefs: {
              type: Array,
              default: function() { return [] }
          },
          value: {
              type: Array | Object,
              default: function() { return [] }
          }
      },
        watch: {
            value(val) {
                this.dataFieldRefs = val
            },
            dataFieldRefs(val) {
                this.$emit('input', val)
            }
        },
      mounted() {
          this.dataFieldRefs = this.value
      },
      data: () => {
          return {
              dataFieldRefs: [],
              Core: window.Core
          }
      },
      methods: {
      }
  }
</script>